import SecurityAuthentication from './SecurityAuthentication';

export default SecurityAuthentication;
